import { useQuery } from '@tanstack/react-query'
import { aiService } from '../services/aiService'
import { useAuth } from './useAuth'

export function useAISuggestions(threadId: string | undefined, messageId: string | undefined) {
  const { isAIEnabled } = useAuth()

  const query = useQuery({
    queryKey: ['ai-suggestions', threadId, messageId],
    queryFn: () => aiService.generateResponses(threadId!, messageId!),
    enabled: isAIEnabled && !!threadId && !!messageId,
  })

  return {
    suggestions: query.data,
    isLoading: query.isLoading,
    error: query.error,
    isEnabled: isAIEnabled,
  }
}

